import { Link } from "react-router-dom";
import { SOCIALS, SUPPORT_EMAIL, SUPPORT_MAILTO } from "@/lib/api";

const cols = [
  { title: "Explore", links: [{ to: "/", label: "Home", id: "footer-home" }, { to: "/blogs", label: "Blogs", id: "footer-blogs" }, { to: "/careers", label: "Careers", id: "footer-careers" }, { to: "/sitemap", label: "Sitemap", id: "footer-sitemap" }] },
  { title: "Legal", links: [{ to: "/privacy-policy", label: "Privacy Policy", id: "footer-privacy" }, { to: "/terms", label: "Terms of Usage", id: "footer-terms" }, { to: "/child-safety", label: "Child Safety", id: "footer-child-safety" }] },
  { title: "Support", links: [{ to: "/help", label: "Help", id: "footer-help" }, { to: "/help", label: "Contact Us", id: "footer-contact" }] },
];

export const Footer = () => (
  <footer className="relative mt-4 sm:mt-10 pt-12 sm:pt-20 pb-[max(2.5rem,env(safe-area-inset-bottom))] overflow-hidden" data-testid="site-footer">
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-2 md:grid-cols-12 gap-8 md:gap-12">
        <div className="col-span-2 md:col-span-5">
          <Link to="/" className="inline-flex" data-testid="footer-logo">
            <img src="/logo.png" alt="TruCitizen" className="h-12 w-auto object-contain" />
          </Link>
          <div className="mt-8">
            <p className="eyebrow !text-[var(--green)] mb-3">Contact us</p>
            <a href={SUPPORT_MAILTO} className="text-sm font-semibold text-[var(--ink)] underline underline-offset-4 decoration-[var(--green)]" data-testid="footer-email">{SUPPORT_EMAIL}</a>
            <p className="text-xs text-[var(--muted)] mt-1">Use subject prefix <span className="font-mono">[TruCitizen]</span> for faster replies.</p>
          </div>
          <div className="mt-6 flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.name} data-testid={`footer-social-${s.id}`}
                className="w-10 h-10 rounded-full border border-black/10 bg-white/60 flex items-center justify-center text-[var(--ink)] transition-all duration-300 hover:bg-[var(--ink)] hover:text-white hover:-translate-y-1">
                <i className={s.icon} aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.title} className="md:col-span-2">
            <p className="eyebrow !text-[var(--green)] mb-4 sm:mb-5">{c.title}</p>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l.id}>
                  {l.to ? (
                    <Link to={l.to} className="inline-block py-1 text-sm font-medium text-[var(--ink-soft)] hover:text-[var(--ink)] transition-colors" data-testid={l.id}>{l.label}</Link>
                  ) : (
                    <a href={l.href} className="inline-block py-1 text-sm font-medium text-[var(--ink-soft)] hover:text-[var(--ink)] transition-colors" data-testid={l.id}>{l.label}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-10 sm:mt-16 pt-6 border-t border-black/[0.08] text-xs text-[var(--muted)]">
        <p data-testid="footer-copyright">Copyright © {new Date().getFullYear()} CreJik Technologies Pvt. Ltd.</p>
      </div>
    </div>
  </footer>
);
